export default "<button type=\"button\" name=\"download\" (click)=\"downloadCVideo()\">Download PPT</button>\n"